// ========================================================
// Dependencies
// ========================================================
@import '~@Green-Dot-Corporation/eureka-lib-style-utils/src/styles/utils/unit-conversion-utils.scss';
@import '~@Green-Dot-Corporation/eureka-lib-theme-utils/src/styles/mixins/typography.scss';
@import '~@Green-Dot-Corporation/eureka-lib-theme-utils/src/styles/utils/theme-utils.scss';

.eureka-callout, %eureka-callout {
    box-sizing: border-box;
    text-align: center;
    $this: '.eureka-callout';

    &__icon-container {
        line-height: 0;
        font-size: 8rem;
    }

    .context-icon__icon {
        font-size: inherit;
    }

    #{$this}__title {
        @include eureka-h5;
        color: var(--eureka-core-color-text, eureka-light-theme('core-color-text'));
    }

    &__msg-container-inner {
        line-height: var(--eureka-core-typography-line-height, eureka-light-theme('core-typography-line-height'));

        > :first-child {
            margin-top: 0;
        }

        > :last-child {
            margin-bottom: 0;
        }
    }

    &__title,
    &__title.eureka-heading,
    &__msg-container-inner {
        @include eureka-max-line-width;
        display: block;
        margin: 0 auto;
    }

    &__title-container,
    &__msg-container {
        margin: 0 auto;
    }

    &__title-container + &__msg-container {
        margin-top: #{eureka-to-px(eureka-light-theme('core-system-scale') * 2)};
    }

    &__text-container,
    &__icon-container {
        + .eureka-callout-actions {
            margin-top: #{eureka-to-px(eureka-light-theme('core-system-scale') * 8)};
        }
    }

    &__icon-container + &__text-container {
        margin-top: #{eureka-to-px(eureka-light-theme('core-system-scale') * 2)};
    }

    &--pad-content {
        padding: #{eureka-to-rem(eureka-light-theme('core-system-scale') * 8)};
    }

    &--affirmative {
        #{$this}__icon-container {
            color: var(--eureka-callout-affirmative-color-icon, eureka-light-theme('callout-affirmative-color-icon'));
        }
    }

    &--error {
        #{$this}__icon-container {
            color: var(--eureka-callout-error-color-icon, eureka-light-theme('callout-error-color-icon'));
        }
    }
}
